var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"title"},[_vm._v(" Поръчка "+_vm._s(_vm.$route.params.order_id)+" ")]),_c('v-card',[_c('v-card-text',[_c('app-order-list',{attrs:{"view":true,"order_items":_vm.order}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }